module.exports = __webpack_public_path__ + "img/sirene.597c1793.svg";